import React from "react";
import { Tab } from "react-bootstrap";
import Dialog from "../../../components/Dialog";
import IModalProps from "../../../model/ModalProps";
import ButtonStyles from "../../../styles/components/ButtonStyles";
import DialogStyles from "../../../styles/components/DialogStyles";
import {
    StyledLegendDiv,
    StyledLegendContainer,
    StyledLegendTab,
} from "../../../styles/pages/Schedule/ScheduleStyle";
import LegendHeader from "./LegendHeader";
import LegendContentColor from "./LegendContentColor";
import LegendContentIcons from "./LegendContentIcons";

const { BtnPrimary } = ButtonStyles;
const { StyledContainerButton } = DialogStyles;

const Legend: React.FC<IModalProps> = ({ open, onClose }) => {
    return (
        <Dialog openModal={open} onHide={onClose}>
            <StyledLegendDiv>
                <LegendHeader />
                <StyledLegendContainer>
                    <StyledLegendTab
                        defaultActiveKey="color"
                        id="controlled-tab-legend"
                        className="mb-1"
                        fill
                        justify
                    >
                        <Tab eventKey="color" title="Cores">
                            <LegendContentColor />
                        </Tab>
                        <Tab eventKey="icon" title="Ícones">
                            <LegendContentIcons />
                        </Tab>
                    </StyledLegendTab>
                </StyledLegendContainer>
            </StyledLegendDiv>
            <StyledContainerButton style={{ marginTop: 10 }}>
                <BtnPrimary onClick={onClose}>Fechar</BtnPrimary>
            </StyledContainerButton>
        </Dialog>
    );
};

export default Legend;
